import {ValidationError} from "@/lib/forms/validators/ValidationError";

export abstract class Validator<T> {
    public abstract validate(value: T): ValidationError[];
}
